import axios from 'axios';
import { useEffect } from 'react';
import { currentUserRequest } from '~/api/auth/currentUserRequest';
import { useAuth } from '~/hooks/useAuth';
import { useReportError } from '~/hooks/useReportError';
export function useCurrentUserLoader() {
    const { token, signOut, initializeInterceptors, userProfile, setUserProfile, status, } = useAuth();
    const reportError = useReportError();
    useEffect(() => {
        if (!token || userProfile) {
            return;
        }
        const source = axios.CancelToken.source();
        initializeInterceptors();
        currentUserRequest({ cancelToken: source.token })
            .then((data) => {
            if (data) {
                setUserProfile(data);
                return;
            }
            setUserProfile(null);
            signOut();
        })
            .catch((error) => {
            if (axios.isAxiosError(error) && error.response?.status !== 401) {
                reportError('Invalid user profile response', error);
            }
            setUserProfile(null);
            signOut();
        });
        return () => source.cancel();
    }, [
        token,
        userProfile,
        initializeInterceptors,
        signOut,
        reportError,
        setUserProfile,
    ]);
    return { status };
}
